module.exports = __webpack_public_path__ + "img/map-static.webp";